import React from 'react';
const kennitala = require('kennitala')
import { formatKennitala, Spinner, formatMoney, getUrlParam } from '../../utils'
import { gettext } from '../../locale'
import moment from 'moment'
import { Bar } from 'react-chartjs-2';


class OfferTable extends React.Component {

    constructor(props) {
        super(props)
        this.formatMoney = this.formatMoney.bind(this)
    }

    formatMoney(value) {
        if (value === 0) {
            return ""
        }
        return this.props.currencyExchange ? `${formatMoney(value * this.props.currencyExchange)} ISK` : formatMoney(value)
    }

    render() {

        let filteredTimeseries = {}

        Object.keys(this.props.timeseries).map(date => {
            let val = {}
            this.props.columns.map(column => {
                if (this.props.timeseries[date][column] !== undefined) {
                    val[column] = this.props.timeseries[date][column]
                }
            })
            if (Object.keys(val).length > 0) {
                filteredTimeseries[date] = val
            }
        })

        return (
    
            <div className="row">
                <div className="col-12">
                    <table className="table table-hover table-offer table-responsive-sm">
                        <thead>
                            <tr>
                                <th>Dags</th>
                                { this.props.columns.map(column => {
                                        return(<th key={gettext(column)} className="text-right">{gettext(column)} <br /> ({gettext(column, "de")})</th>)
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Object.keys(filteredTimeseries).map(date => {
                                    return (
                                        <tr key={date}>
                                            <td>{date}</td>
                                            { this.props.columns.map(column => {
                                                    return (<td key={gettext(column)} className="text-right">{filteredTimeseries[date][column] !== undefined ? this.formatMoney(filteredTimeseries[date][column]): ''}</td>)
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

OfferTable.defaultProps =  {
    timeseries: {},
    columns: [],
    currencyExchange: null,
}

export default OfferTable